<ng-select
  class="dropdown-selector custom-multi-select {{ customClass }}"
  [class.ng-invalid]="invalid"
  [ngStyle]="{ 'min-width': minWidth, 'max-width': maxWidth }"
  [name]="name"
  [placeholder]="placeholder"
  [items]="items"
  [(ngModel)]="selected"
  [multiple]="multiple"
  [maxSelectedItems]="maxSelectedItems"
  [clearable]="clearable"
  [searchable]="searchable"
  [disabled]="disabled"
  [selectOnTab]="true"
  (change)="onChange()"
>
  <ng-template ng-label-tmp let-item="item" let-clear="clear" data-test="label-template">
    <span class="ng-value-label">{{ item.label }}</span>
    <span class="ng-value-icon" (click)="clear(item)" aria-hidden="true">
      <img src="/assets/images/close-small.svg" alt="clear" class="sm-inline-block" />
    </span>
  </ng-template>

  <ng-template
    ng-option-tmp
    let-item="item"
    let-index="index"
    let-search="searchTerm"
    data-test="option-template"
  >
    <span class="sm-flex">
      {{ item.label }}
      <cc-badge *ngIf="item.badgeText" [text]="item.badgeText" class="sm-ml-1"></cc-badge>
    </span>
  </ng-template>
</ng-select>
